module.exports = __webpack_public_path__ + "img/file-pdf.0cae78a0.svg";